export * from './themed';
export * from './provider';

import styled from './themed';
export default styled;
